@if (zipCodeAvailable) {
  <span class="location-input-preview">
    {{ options?.deliveringToText || 'Delivering to' }} {{ sampleAddress }}
    <span class="location-input-preview__separator">|</span>
    <button type="button" class="location-input-preview__change">
      {{ options?.changeAddressLinkText || 'Change' }}
    </button>
  </span>
} @else {
  <div class="location-input-preview__empty">
    <span class="location-input-preview__description">{{ options?.emptyStateDescription }}</span>
    <div class="location-input-preview__row">
      <input
        class="location-input-preview__input"
        type="text"
        [placeholder]="options?.fieldPlaceholder || ''"
        disabled />
      <button
        type="button"
        class="location-input-preview__submit"
        [style.background-color]="options?.buttonColor || null">
        {{ options?.buttonLabel || 'Check shipping' }}
      </button>
    </div>
  </div>
}
